// extracted by mini-css-extract-plugin
export var details = "_ej-0";
export var inspectorPopover = "_ej-1";